import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import global from './modules/global';
import drawer from './modules/drawer';
import feed from './modules/feed';
import casinos from './modules/casinos';
import casino from './modules/casino';
import cities from './modules/cities';
import countries from './modules/countries';
import news from './modules/news';
import insights from './modules/insights';
import offers from './modules/offers';
import map from './modules/map';
import games from './modules/games';
import game from './modules/game';
import suppliers from './modules/suppliers';
import supplier from './modules/supplier';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,

  modules: {
    global,
    drawer,
    feed,
    casinos,
    casino,
    news,
    insights,
    offers,
    map,
    games,
    game,
    suppliers,
    supplier,
    user,
    countries,
    cities,
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/index.js